module.exports = __webpack_public_path__ + "img/ugacreamery-v-474x632.c05e9bd9.jpg";